// tslint:disable
export enum AlternateCardType {
    /**
     * @description Unknown
     */
    Unknown = 0,
    /**
     * @description Previous Client ID
     */
    PreviousClientId = 1,
    /**
     * @description Mobile #
     */
    MobileNumber = 2,
    /**
     * @description Service Request #
     */
    ServiceRequestNumber = 3,
    /**
     * @description 3rd Party ID
     */
    ThirdPartyID = 4,
}
(AlternateCardType as any)['UNKNOWN'] = 0;
(AlternateCardType as any)['PREVIOUSCLIENTID'] = 1;
(AlternateCardType as any)['MOBILENUMBER'] = 2;
(AlternateCardType as any)['SERVICEREQUESTNUMBER'] = 3;
(AlternateCardType as any)['THIRDPARTYID'] = 4;
